import { normalizeModuleDefault } from '@eventbrite/legacy-infra.transformation-utils';

import * as _BREAKPOINTS from './breakpoints.json';

const BREAKPOINTS = normalizeModuleDefault(_BREAKPOINTS);

export { BREAKPOINTS };
